import { CustomColumn } from '../../types/customColumn';
import { BranchDTO } from '../../types/branches/configuration/BranchTypes';

export const branchColumns: CustomColumn<BranchDTO>[] = [
  {
    Header: 'Sucursal',
    accessor: 'name',
    customCell: ({ row }) => (
      <div className="text-sm font-semibold text-black dark:text-white">
        {row.original.name}
      </div>
    ),
  },
  {
    Header: 'Tipo de Establecimiento',
    accessor: 'establishmentTypeName',
    customCell: ({ row }) => (
      <div className="text-sm text-gray-800 dark:text-gray-200">
        {row.original.establishmentTypeName}
      </div>
    ),
  },
  {
    Header: 'Código Establecimiento',
    accessor: 'establishmentCode',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.establishmentCode}
      </span>
    ),
  },
  {
    Header: 'Código Punto de Venta',
    accessor: 'pointOfSaleCode',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.pointOfSaleCode}
      </span>
    ),
  },
  {
    Header: 'Departamento',
    accessor: 'departmentName',
    customCell: ({ row }) => (
      <span className="text-gray-800 dark:text-gray-200 text-sm">
        {row.original.departmentName}
      </span>
    ),
  },
  {
    Header: 'Municipio',
    accessor: 'municipalityName',
    customCell: ({ row }) => (
      <span className="text-gray-700 dark:text-gray-300 text-sm">
        {row.original.municipalityName || '—'}
      </span>
    ),
  },
  {
    Header: 'Estado',
    accessor: 'active',
    customCell: ({ row }) => (
      <span
        className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
          row.original.active
            ? 'bg-green-500 text-white'
            : 'bg-[#DC3545] text-white'
        }`}
      >
        {row.original.active ? 'Activo' : 'Inactivo'}
      </span>
    ),
  },
];
